import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Pages } from "components/pages";

export default function CloudinaryReportsRoute() {

    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }` } exact>
                <Pages.Cloudinary.Archive />
            </Route>
            <Route path={ `${ path }/page/:pageNum` } exact>
                <Pages.Cloudinary.Archive />
            </Route>
            <Route path={ `${ path }/page` } exact>
                <Pages.Cloudinary.Archive />
            </Route>
        </Switch>
    );
}
